import '@/components/AccordionRegister';
import '@/components/cart/CartItemsCountRegister';
import '@/components/cart/cartViewRegister';
import '@/components/drawers';
import {endDrawer, startDrawer} from '@/components/drawers';
import '@/components/newsletterForm';
import {getFeatureFlag} from '@/feature-flags/feature-flags-store';
import {getProduct} from '@/product/product-store';
import '@/scripts/navbar';
import {
  getProductSellingPlans,
  getSellingPlan,
} from '@/selling-plan/selling-plan-store';
import {overrideSettings} from '@/settings/settings-store';
// Enables feature flag tracking in liquid
import {cartStore} from '@/cart/cart-store';
import {optimisticCacheProduct} from '@/cart/optimistic-updates/optimistic-cache-product';
import '@/components/cart/drawer/CartDrawerRegister';
import '@/components/CheckFeatureFlag';
import '@/components/locale-dialog/LocaleDialogRegister';
import '@/components/LocalizedStringLoader';
import {getLocalizedStrings} from '@/localization/localization-store';
import {effect} from '@preact/signals';
import 'vite/modulepreload-polyfill';

/**
 * If the root route of the store changes, update the cart store.
 * This ensures the cart is always translated to the current language and locale.
 */
effect(() => {
  cartStore.rootRoute = getLocalizedStrings().storeRootRoute ?? '/';
});

/**
 * Bind upcart app to the cart drawer state,
 * so they will open and close together.
 */
effect(() => {
  const upcartGlobal = window as unknown as Window & {
    upcartOpenCart?: () => void;
    upcartCloseCart?: () => void;
  };
  if (!upcartGlobal.upcartOpenCart || !upcartGlobal.upcartCloseCart) {
    return;
  }
  if (endDrawer.isOpen) {
    upcartGlobal.upcartOpenCart();
  } else {
    upcartGlobal.upcartCloseCart();
  }
});

(window as unknown as Window & {startDrawer: typeof startDrawer}).startDrawer =
  startDrawer;

(window as unknown as Window & {endDrawer: typeof endDrawer}).endDrawer =
  endDrawer;

(window as unknown as Window & {cart: unknown}).cart = {
  cartStore,
  optimisticCacheProduct,
};

(window as unknown as Window & {product: unknown}).product = {
  getProduct,
};

(window as unknown as Window & {settings: unknown}).settings = {
  overrideSettings,
};

(window as unknown as Window & {plans: unknown}).plans = {
  getProductSellingPlans,
  getSellingPlan,
};

(window as unknown as Window & {featureFlags: unknown}).featureFlags = {
  getFeatureFlag,
};

document.dispatchEvent(new CustomEvent('MainLoaded'));

// Send feature flag to Datadog RUM
getFeatureFlag('bs-1');
